export default function ValidateSms(values: any) {
    let errors:any = {};
    
    if (!values.smskod) {
        errors.smskod = 'Az "SMS kód" mező kötelező!';
    }

    return errors;
}